/* eslint-disable max-len */
import React, { useState } from 'react';
import {
  makeStyles,
  Typography,
  Button,
  IconButton,
  Grid,
  useTheme,
  Divider,
} from '@material-ui/core';
import IconSpecs from 'views/profiles/common/icons/IconSpecs';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { withTranslation } from 'config/i18n';
import Link from 'components/shared/Link';
import Dinero from 'dinero.js';
import StarIcon from '@material-ui/icons/Star';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  gridItem: {
    marginTop: theme.spacing(2),
  },
  motor: {
    backgroundColor: theme.palette.common.white,
    padding: theme.spacing(2),
    position: 'relative',
    // maxWidth: '350px',
    margin: 'auto',
    borderRadius: '6px',
    boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.12)',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    [theme.breakpoints.up('md')]: {
      maxWidth: 'none',
    },
    [theme.breakpoints.up('lg')]: {
      flexDirection: 'row',
      padding: theme.spacing(3),
      boxShadow: 'none',
      borderRadius: '0',
      border: `1px solid ${theme.palette.grey['100']}`,
      alignItems: 'center',
    },
  },
  motorTop: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('lg')]: {
      flexDirection: 'row-reverse',
      height: '100%',
      alignItems: 'center',
    },
  },
  motorTitleHolder: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    [theme.breakpoints.up('lg')]: {
      flexDirection: 'column',
      height: '100%',
    },
  },
  motorTitle: {
    [theme.breakpoints.up('lg')]: {
      maxWidth: '350px',
    },
  },
  motorSubTitle: {
    color: theme.palette.grey['300'],
    [theme.breakpoints.up('lg')]: {
      marginTop: theme.spacing(1),
    },
  },
  specsHolder: {
    marginTop: '-12px',
    marginRight: '-12px',
  },
  specsMd: {
    width: theme.spacing(4.5),
    height: theme.spacing(4.5),
    borderRadius: '50%',
    textAlign: 'center',
    backgroundColor: theme.palette.secondary.light,
    color: theme.palette.common.white,
    cursor: 'pointer',
    '& svg': {
      marginTop: theme.spacing(1.125),
      color: 'inherit',
      height: theme.spacing(2),
    },
  },
  specsLg: {
    color: theme.palette.grey['400'],
    letterSpacing: '1px',
    marginTop: theme.spacing(1.125),
    '& svg': {
      marginRight: theme.spacing(1),
      height: '14px',
    },
  },
  motorImg: {
    margin: theme.spacing(7, 'auto', 3.5),
    width: '252px',
    height: '144px',
    display: 'inline-flex',
    justifyContent: 'center',
    '& img': {
      display: 'block',
      width: 'auto',
      height: '100%',
    },
    [theme.breakpoints.up('lg')]: {
      margin: theme.spacing(0, 6, 0, 0),
    },
  },
  motorInfoHolder: {
    maxWidth: '320px',
    margin: '0 auto',
    width: '100%',
    position: 'relative',
    zIndex: '3',
    [theme.breakpoints.up('lg')]: {
      margin: '0',
      width: '300px',
    },
  },
  limited: {
    backgroundColor: theme.palette.warning.main,
    color: theme.palette.secondary.dark,
    fontWeight: '700',
    fontSize: theme.typography.pxToRem(14),
    padding: theme.spacing(0, 3.75),
    margin: theme.spacing(0, 'auto', 3.5),
    lineHeight: theme.typography.pxToRem(26),
    display: 'inline-block',
    [theme.breakpoints.up('lg')]: {
      margin: theme.spacing(1, 0, 0),
    },
  },
  moreRatesContainer: {
    textAlign: 'right',
  },
  moreRates: {
    color: theme.palette.grey['200'],
    letterSpacing: '1px',
  },
  motorInfo: {
    display: 'flex',
    alignItems: 'stretch',
    padding: theme.spacing(1, 0),
    marginTop: theme.spacing(1),
    flexFlow: 'row nowrap',
    transform: 'translateX(0)',
    textAlign: 'center',
    transition: 'transform 300ms cubic-bezier(0.4, 0.0, 0.2, 1)',
    [theme.breakpoints.up('lg')]: {
      marginBottom: theme.spacing(3),
    },
  },
  info: {
    borderRight: `1px solid ${theme.palette.grey['100']}`,
    paddingRight: theme.spacing(1),
    marginRight: theme.spacing(1),
    flexFlow: 'column',
    flex: '1 1 32%',
    flexBasis: '32%',
    maxWidth: '7.5rem',
    minWidth: '32%',
    '&:last-child': {
      paddingRight: theme.spacing(0),
      marginRight: theme.spacing(0),
      borderRight: 'none',
    },
  },
  price: {
    fontSize: theme.typography.pxToRem(18),
    fontWeight: '500',
    color: theme.palette.secondary.dark,
    marginRight: theme.spacing(0.5),
  },
  per: {
    fontSize: theme.typography.pxToRem(12),
    color: theme.palette.grey['300'],
  },
  discRate: {
    fontSize: theme.typography.pxToRem(16),
    color: theme.palette.grey['300'],
  },
  badges: {
    display: 'flex',
    marginTop: theme.spacing(1.75),

    '.userCentered &': {
      [theme.breakpoints.down('sm')]: {
        justifyContent: 'center',
        marginTop: theme.spacing(1.5),
      },
    },
  },
  badge: {
    backgroundColor: theme.palette.grey['50'],
    border: `1px solid ${theme.palette.grey['100']}`,
    padding: theme.spacing(0.375, 1.125),
    borderRadius: theme.typography.pxToRem(11),
    display: 'flex',
    alignItems: 'center',
    fontSize: theme.typography.pxToRem(14),
    lineHeight: 'normal',
    '& svg': {
      height: theme.typography.pxToRem(16),
      width: theme.typography.pxToRem(16),
      marginLeft: theme.spacing(0.5),
      color: theme.palette.warning.main,
    },
    '&:not(:last-child)': {
      marginRight: theme.spacing(1),
    },
  },
  pricesContainer: {
    overflowX: 'hidden',
  },
  scrollRight: {
    '& $motorInfo': {
      transform: 'translateX(-100%)',
      transition: 'transform 300ms cubic-bezier(0.4, 0.0, 0.2, 1)',
    },
    '& $arrIcn': {
      transform: 'rotate(180deg)',
    },
  },
  arrIcn: {},
  bikeLink: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: '2',
  },
}));

const MotorForRentCard = (props) => {
  const {
    t,
    name,
    location,
    rating,
    tripsCount,
    limitedAailability,
    bikePageurl,
    price,
    image,
    hourly,
  } = props;
  const theme = useTheme();
  const classes = useStyles();
  const isLgScreen = useMediaQuery(theme.breakpoints.up('lg'));

  const [rateToggle, setRateToggle] = useState(false);
  const priceFormate = (amount) => Dinero({
    amount: Math.ceil(amount),
    currency: price.original_price.currency_code,
  }).toFormat('$0,0');

  const discountsArr = price.discounts.filter((discount) => discount.discount_percentage !== null);

  return (
    <>
      <Grid item xs={12} md={6} lg={12} className={classes.gridItem} key={`${image}`}>
        <div className={classes.motor}>
          <Button
            className={classes.bikeLink}
            component={Link}
            target="_blank"
            rel="noopener noreferrer"
            href={bikePageurl}
          />
          <div className={classes.motorTop}>
            <div className={classes.motorTitleHolder}>
              <div className={classes.motorTitle}>
                <Typography variant="h4">{name}</Typography>

                <Typography variant="h5" className={classes.motorSubTitle}>
                  {location}
                </Typography>

                {(rating || tripsCount > 0) && (
                  <div className={classes.badges}>
                    {!!rating && rating > 0 && (
                      <span className={classes.badge}>
                        <span>{rating}</span>
                        <StarIcon />
                      </span>
                    )}
                    {tripsCount > 0 && (
                      <span className={classes.badge}>
                        {tripsCount}
                        {' '}
                        {t('fe_es_profiles:trips')}
                      </span>
                    )}
                  </div>
                )}

                {isLgScreen && limitedAailability && (
                  <div className={classes.limited}>{t('fe_es_profiles:limited_availability')}</div>
                )}
              </div>

              {!isLgScreen && (
                <IconButton
                  component={Link}
                  target="_blank"
                  rel="noopener noreferrer"
                  href={bikePageurl}
                  className={classes.specsHolder}
                >
                  <div className={classes.specsMd}>
                    <IconSpecs />
                  </div>
                </IconButton>
              )}

              {isLgScreen && (
                <Button
                  color="secondary"
                  className={classes.specsLg}
                  component={Link}
                  target="_blank"
                  rel="noopener noreferrer"
                  href={bikePageurl}
                >
                  <IconSpecs />
                  {t('fe_es_profiles:specs')}
                </Button>
              )}
            </div>

            <div className={classes.motorImg}>
              <img src={image} alt={name} />
            </div>
          </div>

          <div className={classes.motorInfoHolder}>
            {!isLgScreen && limitedAailability && (
              <div className={classes.limited}>{t('fe_es_profiles:limited_availability')}</div>
            )}

            <div className={clsx(classes.pricesContainer, { [classes.scrollRight]: rateToggle })}>
              {discountsArr.length > 2 && (
                <div className={classes.moreRatesContainer}>
                  <Button
                    color="secondary"
                    className={classes.moreRates}
                    onClick={() => setRateToggle(!rateToggle)}
                  >
                    {t('fe_es_profiles:more_disc_rates')}
                    <ChevronRightIcon className={classes.arrIcn} />
                  </Button>
                  <Divider />
                </div>
              )}

              <div className={classes.motorInfo}>
                <div className={classes.info}>
                  <div>
                    <span className={classes.price}>
                      {priceFormate(price.original_price.amount)}
                    </span>
                    <span className={classes.per}>
                      {hourly ? t('fe_es_profiles:per_hour') : t('fe_es_profiles:per_day')}
                    </span>
                  </div>
                  {discountsArr.length > 0 && (
                    <div className={classes.discRate}>{`1-3 ${t('fe_es_profiles:days')}`}</div>
                  )}
                </div>
                {discountsArr.map((discount) => (
                  <div className={classes.info} key={discount.discount_percentage}>
                    <div>
                      <span className={classes.price}>
                        {priceFormate(
                          ((100 - discount.discount_percentage) * price.original_price.amount) / 100,
                        )}
                      </span>
                      <span className={classes.per}>{t('fe_es_profiles:per_day')}</span>
                    </div>
                    <div className={classes.discRate}>
                      {`${discount.min_days}${discount.max_days ? `-${discount.max_days}` : '+'} `}
                      {t('fe_es_profiles:days')}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <Button
              fullWidth
              variant="contained"
              color="primary"
              component={Link}
              target="_blank"
              rel="noopener noreferrer"
              href={bikePageurl}
              className={classes.reserveNowAction}
            >
              {t('fe_es_profiles:reserve_now')}
            </Button>
          </div>
        </div>
      </Grid>
    </>
  );
};

export default withTranslation('fe_es_profiles')(MotorForRentCard);
